interface TokenResponse {
    token: string;
    organizationId: string;
}

async function getParams() {
    try {
      const file = await fetch("./env.json");
      const data = await file.json();
      return data || {};
    } catch (err) {
      return {};
    }
  }

export async function getToken(language: string, pageId: string) {
    try {
        const requestHeaders = new Headers();
        requestHeaders.append("Content-Type", "application/json");

        const requestBody = {
          "pageId": pageId
        }

        const requestOptions = {
          method: "POST", 
          headers: requestHeaders,
          body: JSON.stringify(requestBody),
        };

        const response = await fetch(`/ab/api/atomic/${language}/generatetokenproxy`, requestOptions);
        const data = await response.json() as TokenResponse;
        return data;
    } catch (e) {
        console.error(e);
        const params = await getParams();
        const data: TokenResponse = {
            token: params.apiKey,
            organizationId: params.orgId
        };

        return data;
    }
}